module.exports = "<img [src]=\"message.author.photoURL\"/>\n\n<div class=\"info\">\n  <span class=\"name\">{{ message.author.displayName }}</span>\n  <span class=\"date\">{{ message.date | date }}</span>\n</div>\n\n\n<p class=\"content\">{{ message.content }}</p>\n"


//////////////////
// WEBPACK FOOTER
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/chat/message/message.component.html
// module id = ../../../../../src/app/chat/message/message.component.html
// module chunks = main